<template>
	<div class="privateStore">
		<el-dialog
		  :title="!fixAttr ? $t('other.a2072') : $t('other.a2073')"
		  :visible.sync="dialogVisible"
		  width="50%"
		 >
		  <el-form  :model="ruleForm"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
		    <el-form-item v-if="!fixAttr" :label="$t('other.a2074')" prop="region">
		      <el-select class="input-item" v-model="ruleForm.country" :placeholder="$t('other.a2075')">
		        <el-option :label="item.label" :value="item.value" v-for="item in options"></el-option>
		      </el-select>
		    </el-form-item>

            <el-form-item v-if="!fixAttr" :label="$t('other.a2077')" prop="region">
		      <el-select class="input-item" v-model="ruleForm.type" :placeholder="$t('other.a2076')" @change="check">
		        <el-option :label="item.label" :value="item.value" v-for="item in optionsDH"></el-option>
		      </el-select>
		    </el-form-item>
		
			<el-form-item :label="$t('other.a2078')">
				<el-table
				size="medium"
				   border
				  :data="ruleForm.items"
				 >
				  <el-table-column
					
					:label="$t('other.a2079')"
					>
					<template slot-scope="props">
						<el-input @blur="props.row.floor=Number(props.row.floor)" style="width:90px" v-model="props.row.floor"></el-input> ~ 
						<el-input @blur="props.row.ceiling=Number(props.row.ceiling)" style="width:90px" v-model="props.row.ceiling"></el-input>
						
					</template>
				  </el-table-column>
				  <el-table-column
					:label="$t('other.a2080')"
					>
					<template slot-scope="props">
						<el-input @blur="props.row.fee=Number(props.row.fee)" style="width:90px" v-model="props.row.fee"></el-input>  RMB/{{$t('other.a2081')}}
					</template>
				  </el-table-column>
                  
				  <!-- <el-table-column
						:label="$t('other.a33')"
						width="80"
						>
						<template slot-scope="props">
							<span style="cursor: pointer;" v-show="props.$index == 0 " @click="addFee(props.$index)">增 加</span>
							
							<span style="cursor: pointer;"  v-show="props.$index !== 0" @click="delFee(props.$index)">{{$t('other.a273')}}</span>
						</template>
				  </el-table-column>    -->
				 </el-table>
			</el-form-item>
			
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
			<el-button v-if="fixAttr" type="primary" @click="changeRulesCopy()">{{$t('other.a166')}}</el-button>
		    <el-button v-if="!fixAttr" type="primary" @click="submit()">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<div style="font-size: 28px;font-weight: bold;margin-bottom: 20px;text-align: center;">
			  {{$t('other.a2082')}}
		</div>
		
        
		<div style="width: 100%;margin-bottom:100px">
            <el-tabs type="border-card">
                

            <el-tab-pane :label="$t('other.a2083')">
                <div style="margin-bottom: 30px;">
           
                <!-- <el-button type="primary" @click="dialogVisible=true">新增收费规则</el-button> -->
               <span style="margin-left:30px;font-size:22px;">{{$t('other.a2085')}}：</span> 
             <el-select v-model="value" :placeholder="$t('other.a2084')" @change="chooseStore()" >
    <el-option
     
      v-for="item in option_se"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
           

           <el-select v-model="genre" :placeholder="$t('other.a2076')" @change="chooseStore_gn()" style="margin-left:30px">
    <el-option
     
      v-for="item in option_gn"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
			
		</div>

                <el-table
			      :data="list"
			      border
				  
				  style="width: 100%"
			      >
			      <el-table-column
			        prop="id"
			        :label="$t('other.a269')"
			       >
				   <template slot-scope="props">
				   	<span>{{ countryName[props.row.country]}}</span>
				   </template>
			      </el-table-column>
				 <el-table-column
				   prop="id"
				   :label="$t('other.a2079')"
				  >
				  <template slot-scope="props">
                      <!-- <span>{{props.row.startPoint}}次</span> -->
					  	<span v-show="props.row.type=='translate'">{{props.row.endPoint==10000000000?$t('other.a2086'):props.row.endPoint}}</span>
						<span v-show="props.row.type=='conversation'">{{props.row.startPoint}}~{{props.row.endPoint}}</span>

					  <!-- <div v-for="(ttp,index) in props.row.items">
						  <div>
							  <span style="display: inline-block;width: 200px;"><span>{{ttp.floor}}</span>~<span>{{ttp.ceiling}}</span></span> 
							  <span style="margin-left: 20px;">收取费用：{{ttp.fee}}/RMB</span> 
						  </div>
					  </div> -->
				  </template>
				 </el-table-column>
                 <!-- <el-table-column
			        prop="id"
			        label="收费区间终止值"
			       >
				   <template slot-scope="props">
				   	<span>{{props.row.endPoint}}次</span>
				   </template>
			      </el-table-column> -->
                  <el-table-column
			        prop="id"
			        :label="$t('other.a2080')"
			       >
				   <template slot-scope="props">
					   <span v-show="props.row.type=='conversation' && props.row.cost==0">{{$t('other.a2087')}}</span>
				   	<span v-show="props.row.type=='conversation' && props.row.cost!=0">{{props.row.cost}}RMB/{{$t('other.a1337')}}</span>
                    <span v-show="props.row.type=='translate' && props.row.endPoint==10000000000">3RMB/{{$t('other.a2088')}}</span>
					<span v-show="props.row.type=='translate' && props.row.endPoint!=10000000000">{{props.row.cost}}RMB/{{$t('other.a2089')}}</span>
				   </template>
			      </el-table-column>
                  <el-table-column
			        prop="id"
			        :label="$t('other.a2077')"
			       >
				   <template slot-scope="props">
				   	<span>{{translateData[props.row.type] }}</span>
				   </template>
			      </el-table-column>
			      <!-- <el-table-column
			        prop="desc"
					
			        :label="$t('other.a33')">
					<template slot-scope="props">
						<el-button v-show="!props.row.checked" type="primary" size="small"  @click="changeRules(props.row)">{{$t('other.a93')}}</el-button>
						
						<el-button type="primary" size="small" @click="cancelRules(props.row)">{{$t('other.a312')}}</el-button>
					
					</template>
			      </el-table-column> -->
				 
			    </el-table>
				 <el-pagination
              style=""
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage1"
              :page-sizes="[10, 30, 50]"
              :page-size="offset"
              layout=" total,sizes, prev, pager, next, jumper"
              :total="recordTotal">
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane :label="$t('other.a2090')">
                <el-alert
    :title="$t('other.a2091')"
    type="success"
    :closable="false">
  </el-alert>
               <el-table
      :data="tableData"
      size="medium"
				   border
      style="width: 100%">
      <el-table-column
        prop="date"
        :label="$t('other.a481')"
        width="280">
      </el-table-column>
      <el-table-column
        prop="name"
        :label="$t('other.a2092')"
        width="280">
        <template slot-scope="scope">
        
        <span style="margin-left: 10px">{{ scope.row.name }}{{$t('other.a54')}}/{{$t('other.a2081')}}</span>
      </template>
      </el-table-column>
      
    </el-table>
            </el-tab-pane>
            
            </el-tabs>


			
		</div>
		
		 
	 
	</div>
</template>

<script>
	import api from '../../api/api.js'
	export default{
		data(){
			return {
                 tableData: [{
            date: this.$t('chat.Thailand'),
            name: '0.15',
            address: this.$t('other.a2094')
          }, {
            date: this.$t('h5.DSX_index_my'),
            name: '0.25',
            address: this.$t('other.a2095')
          },],
				 recordTotal:0,
				 currentPage1:1,
				  offset:10,
                genre:'',
				list:[],
				fixAttr:false,
                dialogVisible:false,
                countryName:{
                    'TH':this.$t('chat.Thailand'),
                    'PH':this.$t('h5.DSX_index_ph'),
                    'MY':this.$t('other.a1092'),
                    'ID':this.$t('chat.Indonesia'),
                    'SG':this.$t('chat.Singapore'),
                    'TW':this.$t('h5.DSX_index_tw'),
                    'VN':this.$t('h5.DSX_index_vn')
                },
				value:'TH',
				valuecheck:'',
				typecheck:'',
                option_gn: [{
				          value: 'conversation',
				          label: this.$t('other.a2096')
				        }, {
				          value: 'translate',
				          label: this.$t('other.a2097')
				        }],
                option_se: [{
				          value: 'TH',
				          label: this.$t('chat.Thailand')
				        }, {
				          value: 'PH',
				          label: this.$t('h5.DSX_index_ph')
				        }, {
				          value: 'MY',
				          label: this.$t('other.a1092')
				        }, {
				          value: 'ID',
				          label: this.$t('chat.Indonesia')
				        }, {
				          value: 'SG',
				          label: this.$t('chat.Singapore')
				        },{
				          value: 'TW',
				          label: this.$t('h5.DSX_index_tw')
				        },{
				          value: 'VN',
				          label: this.$t('h5.DSX_index_vn')
						},
						
                       ],
				options: [{
				          value: 'TH',
				          label: this.$t('chat.Thailand')
				        }, {
				          value: 'PH',
				          label: this.$t('h5.DSX_index_ph')
				        }, {
				          value: 'MY',
				          label: this.$t('other.a1092')
				        }, {
				          value: 'ID',
				          label: this.$t('chat.Indonesia')
				        }, {
				          value: 'SG',
				          label: this.$t('chat.Singapore')
				        },{
				          value: 'TW',
				          label: this.$t('h5.DSX_index_tw')
				        },{
				          value: 'VN',
				          label: this.$t('h5.DSX_index_vn')
                        }],
                    optionsDH: [{
				          value: 'conversation',
				          label: this.$t('other.a2096')
				        }, {
				          value: 'translate',
				          label: this.$t('other.a2097')
				        }],
				ruleForm: {
                  type:null,
				  country: null,
				  items:[{
					  ceiling:0,
					  floor:0,
					  fee:0
				  }]
				  
                },
               translateData: {
        conversation: this.$t('other.a2096'),
        translate: this.$t('other.a2097'),
        
      },
      ruleId :null,
      cost :null,
      startPoint :null,
      endPoint :null
				    
			}
		},
		created(){
            // this.getPrivateRulse()
            this.getsmart();
		},
		watch:{
			dialogVisible(){
				if(!this.dialogVisible){
                      this.ruleForm.country='';
                      this.ruleForm.type = '';
					  this.ruleForm.items=[{
						  ceiling:0,
						  floor:0,
						  fee:0
					  }]
					  
					
					this.fixAttr=false
				}
			}
		},
		methods:{
			handleSizeChange(size){
      this.offset =size;
      console.log(this.offset);
      if(this.value=='ALL'){
                    
                    this.getsmart();
                    
                }else if(this.genre==''){
					this.getcheck(this.value)
                   
                }else{
					 this.getchoos(this.value);
				}
	},//改变每页数量
	handleCurrentChange(currentPage){
      this.currentPage1 = currentPage
        console.log(this.currentPage1);
       if(this.value=='ALL'){
                    
                    this.getsmart();
                    
                }else if(this.genre==''){
					this.getcheck(this.value)
                   
                }else{
					 this.getchoos(this.value);
				}
    },//分页
            //按地区进行筛选
            chooseStore(){
				this.currentPage1 = 1;
				this.offset = 10;
				console.log(this.genre);
				if(this.value=='ALL' && this.genre==''){
                    
                    this.getsmart();
                    
                }else if(this.genre==''){
					this.getcheck(this.value)
                   
                }else{
					 this.getchoos(this.value);
				}
				
            },
            //按类型进行筛选
            chooseStore_gn(){
                console.log(this.genre);
                if(this.value=='ALL'){
                    this.getgenre_ss(this.genre);
                }else{
                    this.getgenre(this.genre)
                }
                
            },
            //
            getgenre_ss(genre){
                api
				  .getintegral({
                      
                      pageNum : this.currentPage1,
                      pageSize :this.offset,
                      type:genre
                  })
				  .then(res => {
					  this.recordTotal = res.pageInfo.total
                      this.list = res.integralRules;
                      console.log(res.integralRules);
                      
                  })
                  
            },
            getgenre(genre){
                api
				  .getintegral({
                      country:this.value,
                       pageNum : this.currentPage1,
                      pageSize :this.offset,
                      type : genre
                  })
				  .then(res => {
					  this.recordTotal = res.pageInfo.total
                      this.list = res.integralRules;
                      console.log(res.integralRules);
                      
				  })
			},
			getcheck(country){
				api
				  .getintegral({
                      country:country,
                      pageNum : this.currentPage1,
					  pageSize :this.offset,
					  
                  })
				  .then(res => {
					   this.recordTotal = res.pageInfo.total
                      this.list = res.integralRules;
                    //   this.genre = '';
                      console.log(res.integralRules);
                      
				  })
			},
            getchoos(country){
				
                api
				  .getintegral({
                      country:country,
                      pageNum : this.currentPage1,
					  pageSize :this.offset,
					  type:this.genre
                  })
				  .then(res => {
					   this.recordTotal = res.pageInfo.total
                      this.list = res.integralRules;
                    //   this.genre = '';
                      console.log(res.integralRules);
                      
				  })
            },
            check(){
                console.log(this.ruleForm.type);
			},
			// getchecksmart(){
				
			// }
			getsmart(){
                api
				  .getintegral({
					  country:this.value,
					//   type:this.genre,
                      pageNum : this.currentPage1,
                      pageSize :this.offset
                  })
				  .then(res => {
					  console.log(res);
					  this.recordTotal = res.pageInfo.total
					  console.log(res.integralRules.length);
                      this.list = res.integralRules;
                      console.log(res.integralRules);
                      
                  })
                //  this.genre = '';
            },
			addFee(index){
				console.log(index)
				this.ruleForm.items.push({
					ceiling:0,
					floor:0,
					fee:0
				})
			},
			delFee(index){
				console.log(index)
				this.ruleForm.items.splice(index,1)
			},
			cancelRules(item){
                console.log(item);
				this.$confirm(this.$t('other.a2098'), this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a145'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
				}).then(() => {
				  api
				  .deleteintegral({
                      ruleIds : item.ruleId
                  })
				  .then(res => {
				  	if(res.code =='ok') {
						  this.$message.success(this.$t('other.a1232'))
						  
						//   this.getsmart();
						this.getchoos(this.value);
						
				  	}else{
				  		this.$message.warning(res.msg)
				  	}
				  })
				  
				})
				
			},
			
			changeRulesCopy(){
				console.log(this.ruleForm)
					api
					.updateintegral({
                        cost :this.ruleForm.items[0].fee,
                        endPoint :this.ruleForm.items[0].ceiling,
                        ruleId :this.ruleId,
                        startPoint :this.ruleForm.items[0].floor
                    })
					.then(res => {
						if(res.code == 'ok') {
							this.$message.success(this.$t('other.a665'))
							this.dialogVisible=false
							this.getsmart();
							
							
						}else{
							this.$message.warning(res.msg)
						}
					})
			},
			changeRules(item){
				
				console.log(item)
				// this.ruleForm.items=item.items
                // this.ruleForm.country=item.country;
                this.ruleForm.items[0].floor = item.startPoint
                this.ruleId =item.ruleId;
                this.ruleForm.items[0].fee = item.cost ;
                this.ruleForm.items[0].ceiling = item.endPoint;
                // this.startPoint = item.startPoint;
                // this.endPoint = item.endPoint;
				this.fixAttr=true
				this.dialogVisible=true
			
			},
			// getPrivateRulse(){
			// 	api
			// 	.getPrivateRule()
			// 	.then(res => {
			// 		if(res.code === 200) {
						
			// 			res.data.forEach(p => {
			// 				p.checked=false
			// 			})
			// 			this.list=res.data
			// 			console.log('私有仓扣费规则',res.data)
			// 		}
			// 	})
			// },
			submit(){
				console.log(this.ruleForm)
				if(this.ruleForm.country == null){
					this.$message.warning(this.$t('other.a2084'))
					return
				}else if(this.ruleForm.type == null){
                    this.$message.warning(this.$t('other.a2076'))
					return
                }else{
                    api
					.insertintegral({
                        cost : this.ruleForm.items[0].fee,
                        country : this.ruleForm.country,
                        endPoint :this.ruleForm.items[0].ceiling,
                        startPoint : this.ruleForm.items[0].floor,
                        type : this.ruleForm.type
                    })
					.then(res => {
						if(res.code =='ok') {
							this.$message.success(this.$t('other.a2099'))
							this.dialogVisible=false;
							// this.getsmart();//获取所有规则
							if(this.value=='ALL'){
                    
								this.getsmart();
								
							}else if(this.genre==''){
								this.getcheck(this.value)
							
							}else{
								this.getchoos(this.value);
							}
							
							
						}else{
							this.$message.warning(res.msg)
						}
					})
                }
				
				
				
				// console.log('rule',this.ruleForm)
			
				
			
				
				
				
				// api
				// .changePrivateRule(this.ruleForm)
				// .then(res => {
				// 	if(res.code === 200) {
				// 		this.$message.success('成功增加收费规则')
						
				// 		this.getPrivateRulse()
				// 		this.dialogVisible=false
						
				// 	}else{
				// 		this.$message.warning(res.msg)
				// 	}
				// })
			}
		}
	}
</script>

<style>

    .v-modal{
		opacity: 0!important;
		width: 0!important;
		height: 0!important;
	}
	
	.el-dialog__wrapper{
		top:-50px !important;
	}
	

	
	.privateStore .input-item{
		width: 180px;
	}
	
</style>
